<ion-header class="extendido">
  <ion-buttons>
    <ion-button (click)="closeModal()">
      <i class="fa-regular fa-chevron-left chevron-back-button"></i>
    </ion-button>

    <ion-title>{{'Dados do ' | translate}} {{( !pessoa.checkin ? ('Checkin' | translate) : ('Checkout' | translate))}}
    </ion-title>
  </ion-buttons>
</ion-header>


<ion-content>
  <ion-grid class="gradient-container">
    <div class="gradient-overlay"></div>

    <ion-row class="ion-justify-content-center">
      <ion-col size="auto">
        <img [src]="pessoa.foto | image:' '" class="image" />
      </ion-col>
    </ion-row>

    <ion-row class="ion-justify-content-center">
      <ion-col size="auto">
        <p class="nome-pessoa bold-2">
          {{pessoa.id ? pessoa.nome : ("Nenhuma Pessoa Selecionada" |
          translate)}}
        </p>

        <p class="tipo" *ngIf="pessoa.entidade == 'grupoxpessoa'">{{'Participante' | translate}}</p>
        <p class="tipo" *ngIf="pessoa.entidade == 'grupoxvisitante'">{{'Visitante' | translate}}</p>
        <p class="tipo" *ngIf="pessoa.entidade == 'projetoxvisitanteesporadico'">{{'Esporádico' | translate}}</p>
      </ion-col>
    </ion-row>
  </ion-grid>

  <ion-card *ngIf="isMenor">
    <ion-card-header class="card-header">
      {{'Responsável' | translate}}
    </ion-card-header>

    <ion-card-content>
      <div class="list-mini">
        <ion-list>
          <button class="list-item">
            <ion-row class="content-row one-line">

              <ion-col class="item-avatar">
                <img [src]="responsavel.foto | image:' '" class="image" />
              </ion-col>

              <ion-col class="item-content">
                <h3 class="item-title">{{responsavel.nome}}</h3>
                <p>{{responsavel.parentesco}}</p>
              </ion-col>
            </ion-row>
          </button>
        </ion-list>
      </div>
    </ion-card-content>
  </ion-card>

  <ion-card>
    <ion-card-content>
      <form class="sample-form validations-form" [formGroup]="validations_form"
        (ngSubmit)="onSubmit(validations_form.value)">
        <ion-row>
          <ion-col size="12">
            <ion-label position="stacked">{{'Observação' | translate}}</ion-label>
            <ion-textarea rows="5" type="text" formControlName="observacao"></ion-textarea>
          </ion-col>
        </ion-row>

        <div class="down">
          <ion-button expand="block" class="btn-success" type="submit">{{'Realizar ' | translate}}
            {{( !pessoa.checkin ? ('Checkin' | translate) : ('Checkout' | translate))}}</ion-button>
        </div>
      </form>
    </ion-card-content>
  </ion-card>
</ion-content>